export enum ThirdPartyIntegrationTypes {
    JUST_EAT = 'just eat',
    DELIVEROO = 'deliveroo',
    UBER_EATS = 'uber eats',
    ULTRA_ORDER = 'ultra order',
}
